import script from "./Favorites.vue?vue&type=script&setup=true&lang=js"
export * from "./Favorites.vue?vue&type=script&setup=true&lang=js"

import "./Favorites.vue?vue&type=style&index=0&id=b7e90894&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/pet/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-b7e90894"]])

export default __exports__